import { useCallback, useEffect, useState } from "react";
import {
  getCurrencyRates,
  refreshCurrencyRates,
  getDefaultRatesMap,
} from "../services/currencyService";
import { toast } from "../utils/toast";

// Loads conversion rates on mount and exposes a manual refresh. The service
// caches/coalesces requests, so mounting several consumers stays cheap.
export default function useCurrencyRates() {
  const [rates, setRates] = useState(getDefaultRatesMap());
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const next = await getCurrencyRates();
        if (!cancelled) setRates(next);
      } catch {
        // keep default fallback rates
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const refresh = useCallback(async () => {
    try {
      setRefreshing(true);
      setRates(await refreshCurrencyRates());
      toast.success("Conversion rates updated.");
    } catch (e) {
      toast.error(e?.message || "Failed to refresh conversion rates");
    } finally {
      setRefreshing(false);
    }
  }, []);

  return { rates, refreshing, refresh };
}
